import React, { useEffect } from 'react';
import AnnouncementBanner from './AnnouncementBanner';
import WelcomePopup from './WelcomePopup';
import EditModeBar from './EditModeBar';
import Seo from './Seo';

const SCROLL_THRESHOLD_PX = 8;

function setHeaderScrolled(on) {
  document.documentElement.classList.toggle('site-header-scrolled', on);
}

/**
 * Chrome public : header classique en haut de page, pill iOS dès le scroll.
 * Classe html.site-header-scrolled (scrollY > 8px). Offset via
 * --announcement-banner-height (hauteur intrinsèque, sans inset).
 * EditModeBar reste en bas (z plus haut).
 */
export default function SiteChrome({ children }) {
  useEffect(() => {
    const onScroll = () => setHeaderScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      setHeaderScrolled(false);
    };
  }, []);

  return (
    <>
      <a
        href="#contenu"
        className="skip-link fixed left-4 top-4 z-[200] -translate-y-[160%] rounded-full bg-[#3a00e0] px-[1.1rem] py-2.5 text-sm font-semibold leading-tight text-white no-underline shadow-[0_10px_24px_-8px_rgba(58,0,224,0.45)] transition-transform duration-200 focus:translate-y-0 focus-visible:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#fab03a]"
      >
        Aller au contenu
      </a>
      <Seo />
      <AnnouncementBanner />
      <WelcomePopup />
      <EditModeBar />
      {children}
    </>
  );
}
